<template>
  <div v-if="showBanner" class="china-banner">
    <div class="container">
      <div class="banner-content">
        <div class="banner-text">
          <span class="banner-icon">🇨🇳</span>
          为匹配用户属地国家的监管政策，白鲸 已限制中国境内用户访问和使用部分功能
          <a href="#" class="banner-link" @click.prevent="showDetails">了解详情</a>
        </div>
        <button class="banner-close" @click="closeBanner" aria-label="关闭横幅">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessageBox } from 'element-plus'
import { isChineseMainlandIP } from '@/services/geoLocationService'

export default {
  name: 'ChinaBanner',
  setup() {
    const showBanner = ref(false)

    const closeBanner = () => {
      showBanner.value = false
      // 记录关闭时间，当天内不再显示
      localStorage.setItem('china-banner-closed', new Date().toDateString())
    }

    const showDetails = () => {
      ElMessageBox.alert(
        `根据相关法律法规要求，我们限制了部分功能在中国境内的可用性。这可能包括但不限于：

• 部分中国短信服务
• 特定类型的数据处理
• 某些支付方式
• 部分API功能

如需获得完整的功能体验，建议使用香港或者新加坡等国外网络服务。如有疑问，请联系客服。`,
        '功能限制说明',
        {
          confirmButtonText: '我已了解',
          customClass: 'china-banner-dialog'
        }
      )
    }

    const checkShouldShow = async () => {
      try {
        // 检查今天是否已经关闭过横幅
        const lastClosed = localStorage.getItem('china-banner-closed')
        const today = new Date().toDateString()

        if (lastClosed === today) {
          return false
        }

        // 检查是否为中国大陆IP
        const isChinaIP = await isChineseMainlandIP()
        return isChinaIP
      } catch (error) {
        console.error('Error checking China IP:', error)
        return false
      }
    }

    onMounted(async () => {
      showBanner.value = await checkShouldShow()
    })

    return {
      showBanner,
      closeBanner,
      showDetails
    }
  }
}
</script>

<style scoped>
.china-banner {
  background: linear-gradient(90deg, rgba(239, 68, 68, 0.1) 0%, rgba(251, 146, 60, 0.1) 100%);
  border-bottom: 1px solid rgba(239, 68, 68, 0.15);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1002;
  backdrop-filter: blur(8px);
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  min-height: 40px;
}

.banner-text {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: var(--text-primary);
  line-height: 1.4;
  flex: 1;
}

.banner-icon {
  margin-right: 8px;
  font-size: 16px;
}

.banner-link {
  color: var(--primary-color);
  text-decoration: none;
  margin-left: 8px;
  font-weight: 500;
  white-space: nowrap;
}

.banner-link:hover {
  text-decoration: underline;
}

.banner-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  color: var(--text-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
  margin-left: 12px;
  flex-shrink: 0;
}

.banner-close:hover {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--text-primary);
}

@media (max-width: 768px) {
  .banner-text {
    font-size: 12px;
  }

  .banner-icon {
    margin-right: 6px;
    font-size: 14px;
  }

  .banner-link {
    margin-left: 4px;
  }

  .banner-close {
    padding: 4px;
    margin-left: 8px;
  }
}

@media (max-width: 480px) {
  .banner-content {
    padding: 6px 0;
    min-height: 36px;
  }

  .banner-text {
    font-size: 11px;
  }
}
</style>

<style>
.china-banner-dialog .el-message-box {
  border-radius: 12px;
}

.china-banner-dialog .el-message-box__message {
  line-height: 1.6;
  white-space: pre-line;
}
</style>